module.exports = __webpack_public_path__ + "img/logic.dd4c8cc8.svg";